import moment from "moment-timezone";
import { useMemo } from "react";
import { useInfiniteQuery } from "react-query";
import { ApiCommonParams } from "../api/@types/apiTypes";
import { ApiResponse } from "../api/apiResponse";
import SessionModel from "../api/models/SessionModel";
import { sortByDateAndStartTime } from "../components/sessions/helper";
import { showApiErrorMessages } from "../helpers";

export function useInfiniteStudentSessions(
  indexSessions: (
    commonApiParams?: ApiCommonParams | undefined
  ) => Promise<ApiResponse>,
  filters?: object
) {
  const {
    data: sessionsPages,
    fetchNextPage,
    isFetching: isFetchingSessions,
  } = useInfiniteQuery(
    ["studentSessions", filters],
    ({ pageParam = 1 }) => {
      return indexSessions({
        filters: {
          created_between: [
            moment().subtract(pageParam, "month").unix(),
            moment()
              .subtract(pageParam - 1, "month")
              .unix(),
          ],
          ...filters,
        },
      });
    },
    {
      select: (data) => {
        let userSessions: SessionModel[] = [];
        return {
          pages: data.pages.map((pageResponse) => {
            if (pageResponse.isSuccess) {
              userSessions = SessionModel.fromApiResponse(pageResponse.data);
            } else {
              showApiErrorMessages(pageResponse);
            }
            return userSessions;
          }),
          pageParams: data.pageParams,
        };
      },
    }
  );

  const sessions = useMemo(() => {
    if (sessionsPages) {
      return sortByDateAndStartTime(sessionsPages.pages.flat());
    }
    return [];
  }, [sessionsPages]);

  const loadMoreSessions = () => {
    const currentPage = sessionsPages?.pages.length;
    if (currentPage) {
      return fetchNextPage({ pageParam: currentPage + 1 });
    }
  };
  return {
    sessions,
    loadMoreSessions,
    isFetchingSessions,
  };
}
